const GENERIC_BASENAMES = new Set([
  'document.pdf',
  'document',
  'file.pdf',
  'file',
  'download.pdf',
  'download',
  'untitled.pdf',
  'untitled',
]);

export function basenameFromDownloadPath(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return '';
  try {
    if (/^https?:\/\//i.test(trimmed)) {
      const path = new URL(trimmed).pathname;
      return path.split('/').pop()?.trim() || '';
    }
  } catch {
    /* fall through */
  }
  return trimmed.split(/[\\/]/).pop()?.trim() || '';
}

export function isGenericDownloadBasename(name: string): boolean {
  const base = basenameFromDownloadPath(name).toLowerCase();
  return !base || GENERIC_BASENAMES.has(base);
}

/** Prefer editorial title when the stored technical filename is a placeholder. */
export function resolveTitleBasedDownloadFilename(
  title: string,
  technicalFilename: string,
  fallbackId: string,
  defaultExt = 'pdf',
): string {
  const basename = basenameFromDownloadPath(technicalFilename);
  const trimmedTitle = title.trim();
  if (trimmedTitle && isGenericDownloadBasename(basename)) {
    const cleaned = trimmedTitle
      .replace(/[<>:"|?*\u0000-\u001f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    if (/\.[a-z0-9]{1,8}$/i.test(cleaned)) return cleaned;
    return `${cleaned}.${defaultExt}`;
  }
  return basename || `${fallbackId}.${defaultExt}`;
}
